import {Temp} from "../utils/Temp.js";
import {initPreview} from "../utils/WebPreview.ts";
import {msg} from "@/i18n/Message.ts";

const DUPCHECK_DELAY = 500;
/*  Keep these constants in sync with FindDuplicateParties.java */
const REFACTOR_LOCAL = 1;	// refactor using JS local call
const REFACTOR_REMOTE = 2;	// refactor using AJAX remote call
const REFACTOR_REDIR = 3;	// refactor using standard redirect to URL

export class DuplicatePartyChecker {

	constructor(graph, enabled) {
		this.checkingTimer = null;
		this.waitingForDupQuery = false;
		this.nextDupQuery = false;
		this.graph = graph;
		this.enabled = enabled;
	}

	check() {
		if (!this.enabled) return;
		if (this.checkingTimer !== null) clearTimeout(this.checkingTimer);
		this.checkingTimer = setTimeout(()=>{
			this.checkingTimer = null;
			this.queryServerForDuplicates();
		}, DUPCHECK_DELAY);
	}

	queryServerForDuplicates() {
		if (this.waitingForDupQuery) {
			this.nextDupQuery = true;
		} else this.sendQueryForDuplicates();
	}

	sendQueryForDuplicates() {
		this.waitingForDupQuery = true;
		let dquery = this.buildDupQuery();
		$.ajax({
			type: 'POST',
			url: 'findDuplicateParties.do',
			data: JSON.stringify(dquery),
			success: (data) => {
				if (this.nextDupQuery) {
					this.nextDupQuery = false;
					this.sendQueryForDuplicates();	// again...current data are already obsolete
				} else {
					this.waitingForDupQuery = false;
					this.processDuplicatesResponse(data);
				}
			},
			error: (jqXHR, textStatus, errorThrown) => {
				console.log("Cannot check for duplicates: "+textStatus+", "+errorThrown);
				this.waitingForDupQuery = false;
				this.nextDupQuery = false;
			},
			contentType: "application/json",
			dataType: 'json'
		});
	}

	buildDupQuery() {
		const dquery = {};
		dquery.exclude = this.graph.party.id;
		if (Array.isArray(this.graph.party.addresses)) {
			if (this.graph.party.addresses.length > 0) {
				const ctr = this.graph.party.addresses[0].country;
				if (typeof ctr === 'string' && ctr.length === 2) dquery.country = ctr;	// country of the checked record
			}
		}
		dquery.ico = this.graph.party.ico;
		if (this.graph.party.type === 'ORGANIZATION') dquery.company = this.graph.party.company;
		dquery.eaddresses = this.graph.party.eaddresses;
		dquery.birthNumber = this.graph.party.birthNumber;
		if (this.graph.party.symbols && this.graph.party.symbols.length > 0) {
			dquery.symbol = this.graph.party.symbols[0];
		}
		return dquery;
	}

	processDuplicatesResponse(resp) {
		if (resp && resp.count > 0) {
			const cont = $('#ditems');
			cont.empty();
			for (let i = 0; i < resp.duplicates.length; i++) {
				const dup = resp.duplicates[i];
				this.appendDuplicate(cont, dup);
			}
			$('#duplicates').slideDown();
			initPreview(cont);
		} else $('#duplicates').hide();
	}

	appendDuplicate(cont, dup) {
		const div = Temp.tag('div', {clazz: 'ditem'});
		const name = Temp.tag('div', {clazz: 'ditem-title'});
		const ln = Temp.tag('a');
		ln.text(dup.fileAs);
		ln.attr('href', 'editParty.do?id='+dup.id);
		name.append(ln);
		div.append(name);

		if (dup.reason) {
			const desc = Temp.tag('div', { clazz: 'ditem-info ditem-reason'});
			desc.text(dup.reason);
			div.append(desc);
		}

		if (dup.entered) {
			const desc = Temp.tag('div', { clazz: 'ditem-info'});
			let tx = msg('th.entered') + ': ' + dup.entered;
			if (dup.enteredBy) tx = tx + ' (' + dup.enteredBy+')';
			desc.text(tx);
			div.append(desc);
		}

		if (dup.refactorings && dup.refactorings.length > 0) {
			const sops = { clazz: 'action'};
			const refs = Temp.select(sops);
			const solve = $('<option value="-1"></option>');
			solve.text(msg("duplicates.solve"));
			refs.append(solve);
			for (let i = 0; i < dup.refactorings.length; i++) {
				const rop = $('<option></option>');
				rop.html(dup.refactorings[i].title);
				rop.attr('value', i);
				refs.append(rop);
			}
			refs.on('change', (e)=>{ this.applyRefactoring(dup.refactorings, parseInt(refs.val())); });
			div.append(refs);
		}

		cont.append(div);
	}

	applyRefactoring(refs, index) {
		if (index < 0) return;
		const ref = refs[index];
		switch (ref.type) {
			case REFACTOR_LOCAL:
				//this.refactorLocal(ref);
				break;
			case REFACTOR_REMOTE:
				this.refactorRemote(ref);
				break;
			case REFACTOR_REDIR:
				this.refactorRedir(ref);
				break;
		}
	}

	refactorRemote(ref) {
		// Post selected refactoring to the server
		const action = ref.action;
		const params = ref.params;
		$.ajax({
			type: 'POST',
			url: 'refactorParty.do',
			data: JSON.stringify(ref),
			success: (d) => { this.check() },
			error: function(jqXHR, textStatus, errorThrown) {
				console.log("Cannot refactor: "+textStatus+", "+errorThrown);
			},
			contentType: "application/json",
			dataType: 'json'
		});
	}

	refactorRedir(ref) {
		// Pack graph to refactoring
		ref.params.graph = this.graph;

		const frm = $('<form></form>').attr({
			method: 'POST',
			action: 'refactorParty.do'
		}).css({
			display: 'none'
		});
		const inp = $('<input>').attr({
			type: 'hidden',
			name: 'refactoring',
			value: JSON.stringify(ref)
		});
		frm.append(inp);

		$('body').append(frm);
		frm.submit();
	}
}
